import { useQueries } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { LIST_LIMIT_MAX } from '../../../core/constants/network';
import { normalizeList } from '../../../common/package/list';
import { normalizeTask } from '../../../common/package/task';
import { taskKeys } from '../../../global/contexts/work/keys';
import { taskPaths } from '../../../global/contexts/work/paths';
import { BOARD_STATES } from '../utils/board';

// One request per state, in parallel: Core filters workflow_state by equality,
// so "Pendiente" (two states) cannot be one query. Each answer carries its own
// pagination.total, which gives exact counts per column.
export function useBoardTasks({ projectId, repositoryId, tierId }) {
    const results = useQueries({
        queries: BOARD_STATES.map((state) => {
            const params = { workflow_state: state, modality: 'all', limit: LIST_LIMIT_MAX, offset: 0 };
            if (projectId) params.project_id = projectId;
            if (repositoryId) params.repository_id = repositoryId;
            if (tierId) params.tier_id = tierId;
            return {
                queryKey: taskKeys.list({ ...params, board: true }),
                queryFn: async ({ signal }) => normalizeList((await api.get(taskPaths.list(), { params, signal })).data, normalizeTask),
            };
        }),
    });

    const byState = Object.fromEntries(BOARD_STATES.map((state, index) => [state, {
        items: results[index].data?.items ?? [],
        total: results[index].data?.total ?? 0,
    }]));

    return {
        byState,
        isLoading: results.some((result) => result.isPending),
        error: results.find((result) => result.error)?.error ?? null,
        refetch: () => results.forEach((result) => result.refetch()),
    };
}
